import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createApiCall } from 'services'

type UpdatePackageParams = { 
  id: string
  company_id: string | null
}

export const useUpdatePackage = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ['packages', 'update'],
    mutationFn: async ({ id, company_id }: UpdatePackageParams) => {
      const response = await createApiCall({
        method: 'PATCH',
        url: `/packages/${id}`,
        data: { company_id },
      })
      // `createApiCall`'s errorHandler RESOLVES with `error.response` on 4xx/5xx rather than
      // rejecting, so without this check the mutation "succeeds" on a 403 and every caller's
      // onError/catch is dead code — the UI would report an assignment the server refused.
      // Since VRG-253 this endpoint requires PlatformAdmin + `internal_assign_directly`, so a
      // 403 is a reachable, expected outcome, not a theoretical one.
      const status = response?.status
      if (typeof status === 'number' && (status < 200 || status >= 300)) {
        throw new Error(
          (response?.data as any)?.message || 'Could not update the package',
        )
      }
      return response.data as { success: boolean }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['packages'] })
    },
  })

  return mutation
}
